import {useParams} from "react-router-dom";

export default function useBaseUrl() {
    const {locale, projectId} = useParams<{ locale: string, projectId: string }>();

    return "/" + locale + "/" + projectId;
}